<template>
  <el-dialog
    :model-value="true"
    :title="$t('Feedback.Title')"
    width="520px"
    class="feedback-modal"
    :before-close="() => $emit('close')"
    destroy-on-close
  >
    <p class="feedback-modal__hint">{{ $t('Feedback.Hint') }}</p>

    <el-input
      v-model="message"
      type="textarea"
      :rows="5"
      :placeholder="$t('Feedback.Placeholder')"
      maxlength="2000"
      show-word-limit
      autofocus
    />

    <el-checkbox v-model="wantReply" class="feedback-modal__reply-checkbox">
      {{ $t('Feedback.WantReply') }}
    </el-checkbox>

    <p class="feedback-modal__support" v-html="$t('Feedback.SupportLinks')"></p>

    <template #footer>
      <el-button @click="$emit('close')">{{ $t('General.Cancel') }}</el-button>
      <el-button type="primary" :loading="sending" :disabled="!message.trim()" @click="submit">
        {{ $t('Feedback.Submit') }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus'
import FeedbackService from '@/helpers/api/feedback.service'

export default {
  name: 'FeedbackModal',
  emits: ['close', 'sent'],

  props: {
    source: {
      type: String,
      default: 'sidebar',
    },
  },

  data() {
    return {
      message: '',
      wantReply: false,
      sending: false,
    }
  },

  methods: {
    async submit() {
      const text = this.message.trim()
      if (!text) return
      this.sending = true
      try {
        await FeedbackService.send(text, this.source, this.wantReply)
        ElMessage({ message: this.$t('Feedback.Success'), type: 'success' })
        this.$emit('sent')
        this.$emit('close')
      } catch (e) {
        console.error('Failed to send feedback', e)
        ElMessage({ message: this.$t('Feedback.Error'), type: 'error' })
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.feedback-modal__hint {
  color: var(--ui-text-2, #8392ab);
  font-size: 0.875rem;
  margin-bottom: 0.75rem;
}
.feedback-modal__reply-checkbox {
  margin-top: 0.75rem;
}
.feedback-modal__support {
  margin-top: 1rem;
  margin-bottom: 0;
  padding-top: 0.75rem;
  border-top: 1px solid var(--ui-border, #ECEEF3);
  color: var(--ui-text-2, #8392ab);
  font-size: 0.8125rem;
}
.feedback-modal__support :deep(a) {
  color: var(--c-primary-fg, #5e72e4);
  text-decoration: underline;
}
.feedback-modal__support :deep(a:hover) {
  text-decoration: none;
}
</style>
